"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOptionalDataByUrl = void 0;
const getOptionalDataByUrl = url => {
  const taskId = new URL(url).searchParams?.get('task');
  if (taskId) {
    return {
      taskId,
      objectAdditionalInformation: {
        itemType: 'task'
      }
    };
  } else {
    const documentId = new URL(url).searchParams?.get('document');
    if (documentId) {
      return {
        objectAdditionalInformation: {
          itemType: 'loItem',
          itemDocumentID: documentId
        }
      };
    }
    return {};
  }
};
exports.getOptionalDataByUrl = getOptionalDataByUrl;